<template>
  <base-cell
    v-slot:default="{hover}"
    class="group-cell"
    @click="$emit('click', item)"
  >
    <base-avatar
      class="permission-avatar__avatar"
      :size="44"
      inverse
      :img="avatar"
    />
    <base-text class="ml-3">
      {{ item.name }} ({{ item.member_count }})
    </base-text>
    <base-button
      v-if="hover && !(item.is_supergroup || item.via_integration)"
      text
      small
      class="ml-auto delete-button"
      :style="`${isHover ? 'text-decoration: underline !important;' : ''}`"
      @mouseover.native="isHover = true"
      @mouseout.native="isHover = false"
      @click="$emit('delete', item)"
    >
      Delete
    </base-button>
  </base-cell>
</template>

<script>
export default {
  name: 'GroupCell',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isHover: false,
      bkgdColor: '#E6A0A0',
    };
  },
  computed: {
    avatar: {
      get() {
        if (this.item.is_supergroup || this.item.via_integration) {
          return '/img/group_icon_black.png';
        } else {
          return '/img/group_icon_white.png';
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.group-cell {
  min-height: 72px;
  padding-left: 12px;
  padding-right: 12px;
}
.permission-avatar{
  border-radius: 50%;
}
.delete-button{
  font-size: 14px;
  color: #333333;
  // text-decoration: underline;
  letter-spacing: 0.4px;
  margin: 0px;
  padding: 8px 0px;
}
</style>
